import { type ReactNode } from 'react'

import { type ComboPreviewType } from '@/defs/combo'
import { type StatComboType } from '@/defs/stat'

import { StatComboBrackets } from './StatComboBrackets/StatComboBrackets'
import { StatComboColorId } from './StatComboColorId/StatComboColorId'
import { StatComboDeckTotal } from './StatComboDeckTotal/StatComboDeckTotal'
import { StatComboInclusion } from './StatComboInclusion/StatComboInclusion'
import { StatComboRank } from './StatComboRank/StatComboRank'
import { StatComboRequirements } from './StatComboRequirements/StatComboRequirements'
import { StatComboResults } from './StatComboResults/StatComboResults'

type Props = {
  combo: ComboPreviewType
  stat: StatComboType
}

type ConfigType = Record<StatComboType, ({ combo }: { combo: ComboPreviewType }) => ReactNode>

const CONFIG: ConfigType = {
  brackets: ({ combo }) => <StatComboBrackets combo={combo} />,
  colorId: ({ combo }) => <StatComboColorId combo={combo} />,
  deckTotal: ({ combo }) => <StatComboDeckTotal combo={combo} />,
  inclusion: ({ combo }) => <StatComboInclusion combo={combo} />,
  rank: ({ combo }) => <StatComboRank combo={combo} />,
  requirements: ({ combo }) => <StatComboRequirements combo={combo} />,
  results: ({ combo }) => <StatComboResults combo={combo} />,
}

export const StatCombo = ({ combo, stat }: Props) => CONFIG[stat]({ combo })
